import type { EntitySelectorOption } from './types';

/** One option as SelectSearch takes it. */
export interface SelectSearchOptionModel {
	value: number;
	label: string;
	subtitle?: string;
}

/**
 * Puts pinned options (e.g. "Myself", "All reps") ahead of the loaded
 * records. A pinned option is shown only when its label matches the search
 * text (all of them for an empty search) or when the search found the record
 * it stands in for, and it replaces a loaded record with the same id, so the
 * signed-in user is listed once, as "Myself".
 */
export function mergePinnedOptions(
	pinned: ReadonlyArray<EntitySelectorOption> | undefined,
	loaded: ReadonlyArray<SelectSearchOptionModel>,
	query: string,
): Array<SelectSearchOptionModel> {
	const needle = query.trim().toLowerCase();
	const loadedIds = new Set(loaded.map((option) => option.value));
	const shown = (pinned ?? [])
		.filter(
			(option) =>
				needle === '' ||
				option.label.toLowerCase().includes(needle) ||
				// The search found the record a pinned option stands in for
				// (your own name finds "Myself").
				loadedIds.has(option.id),
		)
		.map((option) => ({
			value: option.id,
			label: option.label,
			subtitle: option.subtitle,
		}));
	const pinnedIds = new Set((pinned ?? []).map((option) => option.id));
	return [...shown, ...loaded.filter((option) => !pinnedIds.has(option.value))];
}
